import { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { MMEMParams } from './types';
import { PERSONAS } from './constants';
import SEO from './components/SEO';
import GamePage from './pages/GamePage';
import Dashboard from './pages/Dashboard';
import CbtCompanionPage from './pages/CbtCompanionPage';
import EduEvaluatorPage from './pages/EduEvaluatorPage';
import ProSimLicensePage from './pages/ProSimLicensePage';

export default function App() {
  const [params, setParams] = useState<MMEMParams>(PERSONAS[0].params);
  const [isDark, setIsDark] = useState(() => {
    if (typeof window !== 'undefined') {
      return (
        document.documentElement.classList.contains('dark') ||
        window.matchMedia('(prefers-color-scheme: dark)').matches
      );
    }
    return false;
  });

  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);

  return (
    <>
      <SEO />
      <Routes>
        <Route
          path="/model-playground"
          element={
            <Dashboard
              params={params}
              setParams={setParams}
              isDark={isDark}
              setIsDark={setIsDark}
            />
          }
        />
        <Route path="/" element={<GamePage params={params} />} />
        <Route path="/cbt-companion" element={<CbtCompanionPage />} />
        <Route path="/edu-evaluator" element={<EduEvaluatorPage />} />
        <Route path="/pro-sim-license" element={<ProSimLicensePage />} />
      </Routes>
    </>
  );
}
